import React from 'react';
import { IconButton, useTheme } from '@mui/material';
import { Menu, MenuItem, Sidebar, sidebarClasses, SubMenu } from 'react-pro-sidebar';
import { NavLink, useLocation } from 'react-router-dom';
/* Icons */
import { useState } from 'react';
import FTIcons from 'assets/icons/FTIcons';
import { tokens } from 'theme/tokens';
import { PowerSettingsNewOutlined } from '@mui/icons-material';
import { logoutUser } from 'services/login-service';

const SidebarNav = () => {
  const [collapsed, setCollapsed] = useState(true);
  const toggleSidebar = () => setCollapsed(prev => !prev);


  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleLogout = (evt) => {
    evt.preventDefault();
    logoutUser().then(() => {
      setTimeout(() => {
        window.location.href = '/';
      }, 1000);
    });
  };

  return (
    <Sidebar
      rootStyles={{
        height: '956px',
        padding: '24px 16px 32px 16px',
        [`.${sidebarClasses.container}`]: {
          backgroundColor: colors.base.white,
        },
      }}
      collapsed={collapsed}
      breakPoint='md'
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton
          onClick={() => toggleSidebar()}
        >
          {collapsed ? <FTIcons.RightArrow /> : <FTIcons.LeftArrow />}
        </IconButton>
      </div>
      <Menu
        menuItemStyles={{
          button: ({ level, active, disabled }) => ({
            display: 'flex',                        
            padding: '12px',

            [`&.active`]: {
              backgroundColor: colors.primary.light,
              color: colors.primary.main,
            },
          }),
          icon: ({active}) => ({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: collapsed ? '100%' : 24,
            minWidth: 22,
            fill: active ? colors.primary.dark : colors.base.black,
          }),
          // the active class will be added automatically by react router
          // so we can use it to style the active menu item
        }}
      >
        <MenuItem 
          icon={<FTIcons.NavMenuHomeIcon width={24} height={24} />}
          component={<NavLink to='/app/home' />}
        >
          Home
        </MenuItem>
        <MenuItem icon={<FTIcons.NavMenuDispatchIcon width={24} height={24} />}
          component={<NavLink to='/app/intermodal' />}
        >
          Intermodal Dispatch
        </MenuItem>
        <MenuItem icon={<FTIcons.NavMenuDispatchIcon width={24} height={24} />}
          component={<NavLink to='/app/longhaul' />}
        >
          OTR Dispatch
        </MenuItem>
        <MenuItem icon={<FTIcons.NavMenuLocationIcon width={24} height={24} />}
          component={<NavLink to='/app/locations' />}
        >
          Locations
        </MenuItem>
        {collapsed ? <>
          <MenuItem icon={<FTIcons.NavMenuCustomerIcon width={24} height={24} />} component={<NavLink to='/app/brokers' />}>
            Broker
          </MenuItem>
          <MenuItem icon={<FTIcons.NavMenuDriverIcon width={24} height={24} />} component={<NavLink to='/app/drivers' />}>
            Driver
          </MenuItem>
          <MenuItem icon={<FTIcons.NavMenuEquipmentIcon width={24} height={24} />} component={<NavLink to='/app/equipments' />}>
            Equipment
          </MenuItem>
        </> :
          <SubMenu label='Assets'>
            <MenuItem icon={<FTIcons.NavMenuCustomerIcon width={24} height={24} />} component={<NavLink to='/app/brokers' />}>
              Broker
            </MenuItem>
            <MenuItem icon={<FTIcons.NavMenuDriverIcon width={24} height={24} />} component={<NavLink to='/app/drivers' />}>
              Driver
            </MenuItem>
            <MenuItem icon={<FTIcons.NavMenuEquipmentIcon width={24} height={24} />} component={<NavLink to='/app/equipments' />}>
              Equipment
            </MenuItem>
          </SubMenu>
        }
        {collapsed ? <>
          <MenuItem icon={<FTIcons.NavMenuDollarIcon width={24} height={24} />} component={<NavLink to='/app/accounting' />}>
            Invoice Manager
          </MenuItem>
          <MenuItem icon={<FTIcons.NavMenuCreditCardIcon width={24} height={24} />} component={<NavLink to='/app/payments' />}>
            Driver Settlement
          </MenuItem>
        </> :
          <SubMenu label='Finance'>
            <MenuItem icon={<FTIcons.NavMenuDollarIcon width={24} height={24} />} component={<NavLink to='/app/accounting' />}>
              Invoice Manager
            </MenuItem>
            <MenuItem icon={<FTIcons.NavMenuCreditCardIcon width={24} height={24} />} component={<NavLink to='/app/payments' />}>
              Driver Settlement
            </MenuItem>
          </SubMenu>
        }
        <MenuItem icon={<FTIcons.NavMenuDashboardIcon width={24} height={24} />}          
          component={<NavLink to='/app/dashboard' />}
        >
          Insights
        </MenuItem>
        <MenuItem icon={<FTIcons.CogIcon width={24} height={24} />}
          component={<NavLink to='/app/profile' />}
        >
          My Account
        </MenuItem>
        <MenuItem onClick={handleLogout} icon={<PowerSettingsNewOutlined />}
          component={<NavLink to='/' />}
        >
          Logout
        </MenuItem>
      </Menu>
    </Sidebar>
  );
};

export default SidebarNav;